export default __webpack_public_path__ + "static/media/app-marketplace.20582d32.png";